import { Flex, Form } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { TRIP_PRICE } from "../../../utils/constants"
import { spacings } from "themes/variables"
import { ExtraGuestPriceItem } from "../ExtraGuestPriceItem"

export const ExtraGuestsBlock = ({ form, childrenAllowed, infantsAllowed, passengersAllowed, maxGuests }) => {
  const [t] = useTranslation()
  const guestsIncluded = Form.useWatch(TRIP_PRICE.GUESTS_INCLUDED, form)
  
  // Show additional rates only when guests included < max guests
  const showAdditionalRates = typeof guestsIncluded === "number" && typeof maxGuests === "number" && guestsIncluded < maxGuests

  return (
    <Flex vertical gap={spacings.M}>
      <Text variant="sub" size="md">
        {t("experiences.scheduling.sections.length_and_rates.additional_guest_rates")}
      </Text>
      
      {showAdditionalRates ? (
        <Flex vertical gap={spacings.L}>
          <Text variant="body" size="sm" type="secondary">
            {t("experiences.scheduling.sections.length_and_rates.additional_rates_description")}
          </Text>
          <Flex vertical gap={spacings.XXS}>
            <Text variant="sub" size="md">
              {t("experiences.scheduling.sections.length_and_rates.additional_charges")}
            </Text>
            <ExtraGuestPriceItem 
              name={TRIP_PRICE.PRICE_ADULT} 
              text={t("experiences.scheduling.sections.length_and_rates.adults")} 
              required
            />
            {childrenAllowed && (
              <ExtraGuestPriceItem
                name={TRIP_PRICE.PRICE_CHILD}
                text={t("experiences.scheduling.sections.length_and_rates.children")}
                subText={t("experiences.scheduling.sections.length_and_rates.under_12_years")}
              />
            )}
            {infantsAllowed && (
              <ExtraGuestPriceItem
                name={TRIP_PRICE.PRICE_INFANT}
                text={t("experiences.scheduling.sections.length_and_rates.infants")}
                subText={t("experiences.scheduling.sections.length_and_rates.under_2_years")}
              />
            )}
            {passengersAllowed && (
              <ExtraGuestPriceItem
                name={TRIP_PRICE.PRICE_PASSENGER}
                text={t("experiences.scheduling.sections.length_and_rates.passengers")}
                infoText={t("experiences.scheduling.sections.length_and_rates.passengers_info")}
              />
            )}
          </Flex>
        </Flex>
      ) : (
        <Text variant="body" size="sm" type="secondary">
          {t("experiences.scheduling.sections.length_and_rates.no_additional_rates_needed")}
        </Text>
      )}
    </Flex>
  )
}

ExtraGuestsBlock.propTypes = {
  form: PropTypes.object.isRequired,
  childrenAllowed: PropTypes.bool,
  infantsAllowed: PropTypes.bool,
  passengersAllowed: PropTypes.bool,
  maxGuests: PropTypes.number,
};
